import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Box } from '@fiverr-private/theme';
import { ButtonProps } from '@fiverr-private/button';
import { Container } from '@fiverr-private/layout_components';
import { tabDropdownBorderStyle } from '../ContactButtonStyles/TabContent/TabContent.ve.css';
import { gradientBorderStyle } from './GradientButtonWithOptions.ve.css';

export const GradientButtonWithOptions = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    withBorder?: boolean;
    children: React.ReactNode;
    isStickyContactCTA?: boolean;
  }
>(({ withBorder = false, children, isStickyContactCTA = false }, ref) => (
  <Container
    className={classNames({ [gradientBorderStyle]: withBorder })}
    position="relative"
    zIndex="1"
    paddingX="0"
    marginX={!isStickyContactCTA || withBorder ? { default: '6', sm: '0' } : '0'}
    marginBottom={isStickyContactCTA ? '0' : { default: '6', sm: '0', md: '6' }}
    width={isStickyContactCTA ? '100%' : 'auto'}
    display="flex"
  >
    <Box
      as="button"
      className={classNames({ [tabDropdownBorderStyle]: !withBorder && !isStickyContactCTA })}
      ref={ref}
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height="42px"
      borderRadius="md"
      color="grey_1100"
      fontWeight="semibold"
      borderColor={{ default: 'black', hover: 'transparent' }}
      borderWidth="sm"
      borderStyle="solid"
      backgroundColor={{ default: 'white', hover: withBorder ? 'white' : 'grey_900' }}
      transition={withBorder ? 'border-color 0.3s ease-in-out' : 'none'}
    >
      {children}
    </Box>
  </Container>
));

GradientButtonWithOptions.displayName = 'GradientButtonWithOptions';
